import { render, staticRenderFns } from "./fvAvatar.vue?vue&type=template&id=1f769c79&lang=pug&"
import script from "./fvAvatar.vue?vue&type=script&lang=js&"
export * from "./fvAvatar.vue?vue&type=script&lang=js&"
import style0 from "./fvAvatar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fvAvatar.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/fvAvatar.vue
// module id = 175
// module chunks = 0 1